import { Share2 } from 'lucide-react'
import ToolPage from '../../components/shared/ToolPage'
import type { ToolField } from '../../components/shared/ToolPage'

const fields: ToolField[] = [
  { name: 'topic', label: 'Topic', type: 'text', required: true, placeholder: 'e.g. Product launch announcement' },
  { name: 'audience', label: 'Target Audience', type: 'text', required: true, placeholder: 'e.g. Tech professionals' },
  {
    name: 'tone', label: 'Tone', type: 'select', defaultValue: 'professional',
    options: [
      { value: 'professional', label: 'Professional' },
      { value: 'casual', label: 'Casual' },
      { value: 'friendly', label: 'Friendly' },
      { value: 'expert', label: 'Expert' },
      { value: 'humorous', label: 'Humorous' },
    ],
  },
  { name: 'keywords', label: 'Keywords', type: 'text', placeholder: 'Comma-separated' },
  {
    name: 'platforms', label: 'Platforms', type: 'checkboxes',
    defaultValue: ['twitter', 'linkedin', 'instagram'],
    options: [
      { value: 'twitter', label: 'Twitter/X' },
      { value: 'linkedin', label: 'LinkedIn' },
      { value: 'instagram', label: 'Instagram' },
    ],
  },
]

const platformColors: Record<string, string> = {
  twitter: 'bg-gray-800 text-white',
  linkedin: 'bg-blue-700 text-white',
  instagram: 'bg-pink-600 text-white',
}

function renderResult(data: any) {
  const posts = data?.social_posts || data?.result?.social_posts || []

  return (
    <div className="space-y-4">
      {posts.map((post: any, i: number) => (
        <div key={i} className="border border-gray-200 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <span
              className={`px-2 py-0.5 rounded text-xs font-medium ${platformColors[post.platform] || 'bg-gray-200 text-gray-700'}`}
            >
              {post.platform}
            </span>
            {post.character_count != null && (
              <span className="text-xs text-gray-400">{post.character_count} chars</span>
            )}
          </div>
          <p className="text-sm text-gray-800 whitespace-pre-wrap">{post.text}</p>
          {post.hashtags?.length > 0 && (
            <div className="flex flex-wrap gap-1 mt-2">
              {post.hashtags.map((h: string, j: number) => (
                <span key={j} className="text-xs text-indigo-600">
                  {h.startsWith('#') ? h : `#${h}`}
                </span>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default function SocialPage() {
  return (
    <ToolPage
      title="Social Media Posts"
      icon={Share2}
      description="Generate platform-specific social media content"
      endpoint="/social"
      fields={fields}
      renderResult={renderResult}
    />
  )
}
